import { render, staticRenderFns } from "./addAward.vue?vue&type=template&id=bffc2f64&scoped=true&"
import script from "./addAward.vue?vue&type=script&lang=ts&"
export * from "./addAward.vue?vue&type=script&lang=ts&"
import style0 from "./addAward.vue?vue&type=style&index=0&id=bffc2f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc2f64",
  null
  
)

export default component.exports